import sanitizeHtml from 'sanitize-html';

// const host_url = 'http://192.168.1.15:8080/';
const host_url = 'http://ec2-35-180-227-239.eu-west-3.compute.amazonaws.com:8080/blog-server/';

export async function fetchCommentsByRecipe(articleLabel) {
    const response = await fetch(`${host_url}api/comments/${articleLabel}`);
    return await response.json();
}

export async function fetchCommentsByPartner(partnerLabel) {
    const response = await fetch(`${host_url}api/comments/partner/${partnerLabel}`);
    return await response.json();
}

export async function postRecipeComment(recipeId, comment) {
    comment.text = sanitizeHtml(comment.text.replace(/\n/g, '<br />'));
    var url = new URL(`${host_url}api/comments/${recipeId}`), params = comment;
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    const response = await fetch(url, {
        method: 'post',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        },
        mode: 'no-cors'
    });
    return await response;
}

export async function postPartnerComment(partnerId, comment) {
    comment.text = sanitizeHtml(comment.text.replace(/\n/g, '<br />'));
    var url = new URL(`${host_url}api/comments/partner/${partnerId}`), params = comment;
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    const response = await fetch(url, {
        method: 'post',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        },
        mode: 'no-cors'
    });
    return await response;
}



// WEBPACK FOOTER //
// ./src/service/comments.js